import { createElement, lazy } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router'

import { ScannerPage } from './pages/scaner/scanner-page'
import { Layout } from '@/components/layout/layout'
import { routes } from '@/constants/routes'
import { PrivateRouteProvider } from '@/providers/private-route-provider'

const NotFoundPage = lazy(() => import('@/pages/not-found-page'))

const LoginPage = lazy(() => import('@/pages/login/login-page'))
const PasswordResetPage = lazy(() => import('@/pages/password-reset/password-reset-page'))
const PasswordResetConfirmPage = lazy(
  () => import('@/pages/password-reset-confirm/password-reset-confirm-page')
)
const PackagingPage = lazy(() => import('@/pages/packaging/packaging-page'))
const PackagingOrderPage = lazy(() => import('@/pages/packaging/order/packaging-order-page'))
const PackingListPage = lazy(() => import('@/pages/packing-list/packing-list-page'))
const MultiOrderSkidsPage = lazy(() => import('@/pages/multi-order-skids/multi-order-skids-page'))
const MachinePage = lazy(() => import('@/pages/machine/machine-page'))
const SchedulingPage = lazy(() => import('@/pages/scheduling/scheduling-page'))
const SettingsPage = lazy(() => import('@/pages/settings/settings-page'))
const PackagingPlayground = lazy(() => import('@/pages/playground/packaging-playground'))
const DeliveriesPage = lazy(() => import('@/pages/deliveries/deliveries-page'))

const router = createBrowserRouter([
  {
    path: routes.scheduling,
    element: (
      <PrivateRouteProvider>
        <Layout />
      </PrivateRouteProvider>
    ),
    children: [
      {
        path: routes.order,
        element: <PackagingOrderPage />
      },

      {
        path: routes.packaging,
        element: <PackagingPage />
      },
      {
        path: routes.packingList,
        element: <PackingListPage />
      },
      {
        path: routes.multiOrderSkids,
        element: <MultiOrderSkidsPage />
      },
      {
        path: routes.machines,
        element: <MachinePage />
      },
      {
        index: true,
        element: <SchedulingPage />
      },

      {
        path: routes.deliveries,
        element: <DeliveriesPage />
      },
      {
        path: routes.settings,
        element: <SettingsPage />
      },

      { path: routes.scanner, element: <ScannerPage /> },
      // Dev-only UI playground; never routed in a production build.
      ...(import.meta.env.DEV
        ? [
            { path: '/playground/packaging', element: <PackagingPlayground /> },
            {
              path: '/playground/deliveries',
              element: createElement(lazy(() => import('@/pages/playground/deliveries-playground')))
            }
          ]
        : [])
    ]
  },
  {
    path: routes.scheduling,
    element: <Layout withSidebar={false} />,
    children: [
      {
        path: routes.login,
        element: <LoginPage />
      },
      {
        path: routes.passwordReset,
        element: <PasswordResetPage />
      },
      {
        path: routes.passwordResetConfirm,
        element: <PasswordResetConfirmPage />
      }
    ]
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
])

export const App = () => <RouterProvider router={router} />
